const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/',
  ADMIN: '/admin',
  ORDER_TYPES: '/order-types',
  PRODUCTS: '/products',
  REORDER_PRODUCTS: '/reorder',
  PRODUCER_ORDERS: '/producer_order',
  PUBLIC: '/public',
};

// ----------------------------------------------------------------------

export const paths = {
  root: '/',
  // comingSoon: '/coming-soon',
  // maintenance: '/maintenance',
  // page500: '/500',
  page403: '/403',
  page404: '/404',
  cookies: '#',

  // dummy paths for avoid build fail
  // faqs: 'faqs/',
  // minimalUI: '/minimalUI',
  // contact: '/contact',
  // changelog: '/changelog',
  // about: '/about',
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  // AUTH
  auth: {
    root: ROOTS.AUTH,
    verify: `${ROOTS.AUTH}/verify`,
    // jwt: {
    //   login: `${ROOTS.AUTH}/login`,
    // },
    // firebase: {
    //   login: `${ROOTS.AUTH}/login`,
    //   register: `${ROOTS.AUTH}/register`,
    //   // forgotPassword: `${ROOTS.AUTH}/forgot-password`,
    // },
    login: `${ROOTS.AUTH}/login`,
  },
  // CUSTOMER
  customer: {
    catalog: `/catalog`,
    checkout: `/checkout`,
    paymentStatus: `/payment-status`,
    orders: { root: `/orders`, details: (order_code: string) => `/orders/${order_code}` },
    producers: '/producers',
  },
  public: {
    downloadProducts: (token: string) => `/downloads/clientPdf/${token}`,
    generic: '/downloads/listino-aggiornato.pdf',
    productPdfPreview: `${ROOTS.PUBLIC}/product-pdf-preview`,
    listinoPreview: '/pdf/listino-aggiornato',
    exciseReport: '/excise-report',
  },
  // ADMIN
  admin: {
    root: ROOTS.ADMIN,
    orderTypes: {
      producerOrders: {
        root: `${ROOTS.ADMIN}/producer-orders`,
        new: `${ROOTS.ADMIN}/producer-orders/new`,
        edit: (order_code: string) => `${ROOTS.ADMIN}/producer-orders/${order_code}/edit`,
        details: (order_code: string) => `${ROOTS.ADMIN}/producer-orders/${order_code}`,
      },
      clientOrders: {
        root: `${ROOTS.ADMIN}/client-orders`,
        new: `${ROOTS.ADMIN}/client-orders/new`,
        edit: (order_code: string) => `${ROOTS.ADMIN}/client-orders/${order_code}/edit`,
        details: (order_code: string) => `${ROOTS.ADMIN}/client-orders/${order_code}`,
      },
    },
    dashboard: {
      operations: `${ROOTS.ADMIN}/dashboard/operations`,
      overview: `${ROOTS.ADMIN}/dashboard/overview`,
      overlays: {
        root: `${ROOTS.ADMIN}/overlay`,
        new: `${ROOTS.ADMIN}/overlay/new`,
        edit: (overlayId: string) => `${ROOTS.ADMIN}/overlay/${overlayId}/edit`,
        details: (overlayId: string) => `${ROOTS.ADMIN}/overlay/${overlayId}`,
      },
      table_text: `${ROOTS.ADMIN}/dashboard/table-text`,
    },
    clients: {
      root: `${ROOTS.ADMIN}/clients`,
      new: `${ROOTS.ADMIN}/clients/new`,
      edit: (slug: string) => `${ROOTS.ADMIN}/clients/${slug}/edit`,
      details: (slug: string) => `${ROOTS.ADMIN}/clients/${slug}`,
    },
    companies: {
      root: `${ROOTS.ADMIN}/companies`,
      details: (companyId: string) => `${ROOTS.ADMIN}/companies/${companyId}`,
    },
    users: {
      root: `${ROOTS.ADMIN}/users`,
      new: `${ROOTS.ADMIN}/users/new`,
      edit: (slug: string) => `${ROOTS.ADMIN}/users/${slug}/edit`,
      details: (slug: string) => `${ROOTS.ADMIN}/users/${slug}`,
    },
    reservations: {
      root: `${ROOTS.ADMIN}/reservations`,
      new: `${ROOTS.ADMIN}/reservations/new`,
      edit: (client_slug: string, sku: string) =>
        `${ROOTS.ADMIN}/reservations/${client_slug}/product/${sku}/edit`,
    },
    discounts: {
      root: `${ROOTS.ADMIN}/discounts`,
    },
    reconciliation: {
      root: `${ROOTS.ADMIN}/reconciliation`,
    },
    agents: {
      root: `${ROOTS.ADMIN}/agents`,
      new: `${ROOTS.ADMIN}/agents/new`,
      edit: (slug: string) => `${ROOTS.ADMIN}/agents/${slug}/edit`,
      details: (slug: string) => `${ROOTS.ADMIN}/agents/${slug}`,
    },
    tastings: {
      root: `${ROOTS.ADMIN}/tastings`,
      new: `${ROOTS.ADMIN}/tastings/new`,
      edit: (slug: string) => `${ROOTS.ADMIN}/tastings/${slug}/edit`,
      details: (slug: string) => `${ROOTS.ADMIN}/tastings/${slug}`,
    },
    products: {
      root: `${ROOTS.ADMIN}${ROOTS.PRODUCTS}`,
      new: `${ROOTS.ADMIN}${ROOTS.PRODUCTS}/new`,
      edit: (sku: string) => `${ROOTS.ADMIN}${ROOTS.PRODUCTS}/${sku}/edit`,
      details: (sku: string) => `${ROOTS.ADMIN}${ROOTS.PRODUCTS}/${sku}`,
    },
    targets: {
      root: `${ROOTS.ADMIN}/targets`,
    },
    controls: {
      root: `${ROOTS.ADMIN}/controls`,
    },
    catalogPdf: {
      root: `${ROOTS.ADMIN}/catalog-pdf`,
    },
    reorderProducts: {
      root: `${ROOTS.ADMIN}${ROOTS.REORDER_PRODUCTS}`,
    },
    producers: {
      root: `${ROOTS.ADMIN}/producers`,
      new: `${ROOTS.ADMIN}/producers/new`,
      edit: (slug: string) => `${ROOTS.ADMIN}/producers/${slug}/edit`,
      details: (slug: string) => `${ROOTS.ADMIN}/producers/${slug}`,
    },
    wineTypes: {
      root: `${ROOTS.ADMIN}/wine-types`,
      new: `${ROOTS.ADMIN}/wine-types/new`,
      edit: (slug: string) => `${ROOTS.ADMIN}/wine-types/${slug}/edit`,
      details: (slug: string) => `${ROOTS.ADMIN}/wine-types/${slug}`,
    },
    selections: {
      root: `${ROOTS.ADMIN}/selections`,
      new: `${ROOTS.ADMIN}/selections/new`,
      edit: (id: string) => `${ROOTS.ADMIN}/selections/${id}/edit`,
      details: (id: string) => `${ROOTS.ADMIN}/selections/${id}`,
    },
    wineCategory: {
      root: `${ROOTS.ADMIN}/wine-category`,
    },
    grapeTypes: {
      root: `${ROOTS.ADMIN}/grape-types`,
      new: `${ROOTS.ADMIN}/grape-types/new`,
      edit: (slug: string | null) => `${ROOTS.ADMIN}/grape-types/${slug}/edit`,
      details: (slug: string) => `${ROOTS.ADMIN}/grape-types/${slug}`,
    },
    territory: {
      root: `${ROOTS.ADMIN}/territory`,
      new: `${ROOTS.ADMIN}/territory/new`,
      edit: (slug: string | null) => `${ROOTS.ADMIN}/territory/${slug}/edit`,
      details: (slug: string) => `${ROOTS.ADMIN}/territory/${slug}`,
    },
    statisticTypes: {
      root: `${ROOTS.ADMIN}`,
      profitability: `${ROOTS.ADMIN}/profitability`,
      profitability_details: (slug: string) => `${ROOTS.ADMIN}/profitability_details/${slug}`,
    },
    producer_orders: {
      details: (order_code: string) => `${ROOTS.ADMIN}${ROOTS.PRODUCER_ORDERS}/${order_code}`,
    },
  },
  // AGENT
  agent: {
    dashboard: '/agent/dashboard',
    clientDetail: (slug: string) => `/agent/clients/${slug}`,
  },
};
